export const URL_INFO = "conference/result";
export const URL_LIST = "shareholder/condition-shareholder/report";
export const URL_CREATE = 'shareholder/condition-shareholder/report';

export const GET_LIST = "GET_INSPECTION_RECORDS_LIST";
export const GET_STATISTIC = "GET_INSPECTION_RECORDS_STATISTIC";
